import React from "react";

import { ToggleGroup, ToggleGroupItem } from "@/src/components/ui/toggle-group";

import type { JSX } from "react";

export interface ToggleOption<TValue extends string> {
  value: TValue;
  label: string;
}

interface ToggleOptionGroupProps<TValue extends string> {
  ariaLabel: string;
  value: TValue;
  optionList: readonly ToggleOption<TValue>[];
  onChange: (value: TValue) => void;
}

function ToggleOptionGroup<TValue extends string>({
  ariaLabel,
  value,
  optionList,
  onChange,
}: ToggleOptionGroupProps<TValue>): JSX.Element {
  // Radix emits "" when the active item is clicked again.
  const handleValueChange = (nextValue: string): void => {
    const option = optionList.find(
      (candidate) => candidate.value === nextValue,
    );
    if (option) onChange(option.value);
  };

  return (
    <ToggleGroup
      aria-label={ariaLabel}
      onValueChange={handleValueChange}
      size="sm"
      type="single"
      value={value}
      variant="outline"
    >
      {optionList.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value}>
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}

export default ToggleOptionGroup;
